import React from 'react'
import { makeStyles } from '@material-ui/core'
import classnames from 'classnames'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 2, 2, 3),
    overflowX: 'hidden'
  }
}))

export default function BaseSidebarPage({ children, className }: { children: React.ReactNode; className?: string }) {
  const classes = useStyles({})
  return <div className={classnames(classes.root, className)}>{children}</div>
}
